export function withVisibleConvertedFiles(log) {
  if (Array.isArray(log.file_scaricati) && log.file_scaricati.length > 0) {
    return log;
  }

  const archivedNames = (log.archived_files || [])
    .map((file) => file.display_name || file.file_name)
    .filter(Boolean);

  return { ...log, file_scaricati: archivedNames };
}
